import type { RowSelectionState, Updater } from "@tanstack/react-table";
import type { ApplyCloseTemplateWizardValues } from "./applyCloseTemplate.schema";

export function buildRowSelectionFromEntityRows(
    entityRows: ApplyCloseTemplateWizardValues["entityRows"],
): RowSelectionState {
    const selection: RowSelectionState = {};
    for (const [id, row] of Object.entries(entityRows)) {
        if (row.isSelected) {
            selection[id] = true;
        }
    }
    return selection;
}

export function applyRowSelectionToEntityRows(
    entityRows: ApplyCloseTemplateWizardValues["entityRows"],
    defaults: ApplyCloseTemplateWizardValues["defaults"],
    selection: RowSelectionState,
): ApplyCloseTemplateWizardValues["entityRows"] {
    const next = { ...entityRows };
    for (const id of Object.keys(next)) {
        const selected = selection[id];
        const prevRow = next[id];
        if (prevRow.isSelected === selected) {
            continue;
        }
        next[id] = selected
            ? {
                  ...prevRow,
                  isSelected: true,
                  startDate: defaults.startDate,
                  endDate: defaults.endDate,
                  workStartDate: defaults.workStartDate,
                  workDeliveryDate: defaults.workDeliveryDate,
                  preparerId: defaults.preparerId,
                  reviewerId: defaults.reviewerId,
                  managerId: defaults.managerId,
              }
            : { ...prevRow, isSelected: false };
    }
    return next;
}

export function resolveRowSelectionUpdater(
    updater: Updater<RowSelectionState>,
    prev: RowSelectionState,
): RowSelectionState {
    return typeof updater === "function" ? updater(prev) : updater;
}
